'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name schemaFormBuilder
   * @description
   *
   */
  angular.module('schemaFormBuilder', ['builder', 'ui.bootstrap']);
})();
angular.module('schemaFormBuilder').run(['$templateCache', function($templateCache) {
  $templateCache.put('builder/decorators/typehead/bootstrap-typehead-decorator.tpl.html',
    '<div class="form-group">\n' +
    '  <label class="control-label" ng-if="showTitle()">{{showTitle()}}</label>\n' +
    '  <input class="form-control" type="text" ng-model="$$value$$"\n' +
    '         uib-typeahead="item for item in form.options | filter:$viewValue | limitTo:8">\n' +
    '</div>');
}]);

angular.module('schemaFormBuilder').run(['$templateCache', function($templateCache) {
  $templateCache.put('builder/decorators/simple-array/bootstrap-simple-array-decorator.tpl.html',
    '<div sf-array="form" class="schema-form-array {{form.htmlClass}}" ng-model="$$value$$"\n' +
    '     ng-model-options="form.ngModelOptions"><label class="control-label" ng-show="showTitle()">{{ form.title }}</label>\n' +
    '  <ol class="list-group" ng-model="modelArray" ui-sortable="">\n' +
    '    <li class="list-group-item {{form.fieldHtmlClass}}" ng-repeat="item in modelArray track by $index">\n' +
    '      <button ng-hide="form.readonly || form.remove === null" ng-click="deleteFromArray($index)"\n' +
    '              style="position: absolute;z-index: 20;right: 10px;" type="button" class="close pull-right"><span\n' +
    '          aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>\n' +
    '      <sf-decorator ng-init="arrayIndex = $index" form="copyWithIndex($index)"></sf-decorator>\n' +
    '    </li>\n' +
    '  </ol>\n' +
    '  <div class="clearfix" style="padding: 15px;">\n' +
    '    <button ng-hide="form.readonly || form.add === null" ng-click="appendToArray()" type="button"\n' +
    '            class="btn {{ form.style.add || \'btn-default\' }} pull-right"><i class="glyphicon glyphicon-plus"></i> {{\n' +
    '      form.add || \'Add\'}}\n' +
    '    </button>\n' +
    '  </div>\n' +
    '  <div class="help-block" ng-show="(hasError() && errorMessage(schemaError())) || form.description"\n' +
    '       ng-bind-html="(hasError() && errorMessage(schemaError())) || form.description"></div>\n' +
    '</div>');
}]);

angular.module('schemaFormBuilder').run(['$templateCache', function($templateCache) {
  $templateCache.put('builder/decorators/select-box/bootstrap-select-box-decorator.tpl.html',
    '<div class="form-group">\n' +
    '  <label class="control-label" ng-if="showTitle()">{{showTitle()}}</label>\n' +
    '  <select-box model="$$value$$" config="form.config" value-field="{{form.valueField}}" display-field="{{form.displayField}}"></select-box>\n' +
    '</div>');
}]);

angular.module('schemaFormBuilder').run(['$templateCache', function($templateCache) {
  $templateCache.put('builder/decorators/number/bootstrap-number-decorator.tpl.html',
    '<div class="form-group schema-form-{{form.type}} {{form.htmlClass}}"\n' +
    '     ng-class="{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess(), \'has-feedback\': form.feedback !== false }">\n' +
    '  <label class="control-label {{form.labelHtmlClass}}" ng-class="{\'sr-only\': !showTitle()}"\n' +
    '         for="{{form.key.slice(-1)[0]}}">{{form.title}}</label>\n' +
    '  <input  string-to-number ng-if="!form.fieldAddonLeft && !form.fieldAddonRight" ng-show="form.key" type="number" step="{{ form.precision || \'any\' }}"\n' +
    '         sf-changed="form" placeholder="{{form.placeholder}}" class="form-control {{form.fieldHtmlClass}}"\n' +
    '         id="{{form.key.slice(-1)[0]}}" ng-model-options="form.ngModelOptions" ng-model="$$value$$"\n' +
    '         ng-disabled="form.readonly" schema-validate="form" name="{{form.key.slice(-1)[0]}}"\n' +
    '         aria-describedby="{{form.key.slice(-1)[0] + \'Status\'}}">\n' +
    '  <div ng-if="form.fieldAddonLeft || form.fieldAddonRight"\n' +
    '       ng-class="{\'input-group\': (form.fieldAddonLeft || form.fieldAddonRight)}">\n' +
    '    <span ng-if="form.fieldAddonLeft" class="input-group-addon" ng-bind-html="form.fieldAddonLeft"></span>\n' +
    '    <input  string-to-number ng-show="form.key" type="number" step="{{ form.precision || \'any\' }}" sf-changed="form"\n' +
    '           placeholder="{{form.placeholder}}" class="form-control {{form.fieldHtmlClass}}"\n' +
    '           id="{{form.key.slice(-1)[0]}}" ng-model-options="form.ngModelOptions" ng-model="$$value$$"\n' +
    '           ng-disabled="form.readonly" schema-validate="form" name="{{form.key.slice(-1)[0]}}"\n' +
    '           aria-describedby="{{form.key.slice(-1)[0] + \'Status\'}}">\n' +
    '    <span ng-if="form.fieldAddonRight" class="input-group-addon" ng-bind-html="form.fieldAddonRight"></span>\n' +
    '  </div>\n' +
    '  <span ng-if="form.feedback !== false" class="form-control-feedback"\n' +
    '        ng-class="evalInScope(form.feedback) || {\'glyphicon\': true, \'glyphicon-ok\': hasSuccess(), \'glyphicon-remove\': hasError() }"\n' +
    '        aria-hidden="true">\n' +
    '  </span> <span ng-if="hasError() || hasSuccess()" id="{{form.key.slice(-1)[0] + \'Status\'}}"\n' +
    '                class="sr-only">{{ hasSuccess() ? \'(success)\' : \'(error)\' }}</span>\n' +
    '  <div class="help-block" sf-message="form.description"></div>\n' +
    '</div>');
}]);

angular.module('schemaFormBuilder').run(['$templateCache', function($templateCache) {
  $templateCache.put('builder/decorators/datepicker/datepicker.html',
    '<div class="form-group schema-form-{{form.type}} {{form.htmlClass}}"\n' +
    '     ng-class="{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess(), \'has-feedback\': form.feedback !== false }">\n' +
    '  <label class="control-label {{form.labelHtmlClass}}" ng-class="{\'sr-only\': !showTitle()}"\n' +
    '         for="{{form.key.slice(-1)[0]}}">{{form.title}}</label>\n' +
    '\n' +
    '  <p class="input-group">\n' +
    '      <!--TODO:: removed schema-validate="form" consider having a custom validator-->\n' +
    '      <input type="text"\n' +
    '           id="{{form.key.slice(-1)[0]}}"\n' +
    '           class="form-control"\n' +
    '           sf-changed="form"\n' +
    '           placeholder="{{form.placeholder}}"\n' +
    '           uib-datepicker-popup="dd.MM.yyyy"\n' +
    '           ng-model="$$value$$"\n' +
    '           ng-model-options="form.ngModelOptions"\n' +
    '           is-open="form.open"\n' +
    '           min-date="form.minDate"\n' +
    '           max-date="form.maxDate"\n' +
    '           init-date="form.defaultDate"\n' +
    '           close-text="Close"/>\n' +
    '        <span class="input-group-btn">\n' +
    '             <button type="button" class="btn btn-default" ng-click="form.open = !form.open"><i\n' +
    '                 class="fa fa-calendar-o"></i></button>\n' +
    '        </span>\n' +
    '  </p>\n' +
    '  <span class="help-block">{{ (hasError() && errorMessage(schemaError())) || form.description}}</span>\n' +
    '</div>');
}]);

angular.module('schemaFormBuilder').run(['$templateCache', function($templateCache) {
  $templateCache.put('builder/decorators/ace/ui-ace.html',
    '<div class="form-group" ng-class="{\'has-error\': hasError()}">\n' +
    '    <label class="control-label" ng-show="showTitle()">{{form.title}}</label>\n' +
    '\n' +
    '    <div ui-ace="form.aceOptions" style="form.style" ng-model="$$value$$" schema-validate="form"></div>\n' +
    '\n' +
    '    <span class="help-block">{{ (hasError() && errorMessage(schemaError())) || form.description}}</span>\n' +
    '</div>');
}]);

angular.module('schemaFormBuilder').run(['$templateCache', function($templateCache) {
  $templateCache.put('builder/decorators/accordion-array/bootstrap-accordion-array-decorator.tpl.html',
    '<div sf-array="form" class="schema-form-array {{form.htmlClass}}" ng-model="$$value$$"\n' +
    '     ng-model-options="form.ngModelOptions">\n' +
    '    <uib-accordion ng-model="modelArray" ui-sortable="">\n' +
    '        <uib-accordion-group ng-repeat="item in modelArray track by $index" is-open="item.open">\n' +
    '            <uib-accordion-heading class="{{form.fieldHtmlClass}}">\n' +
    '                {{interp(form.title,{\'$index\':$index, value: item}) || $index}}\n' +
    '            </uib-accordion-heading>\n' +
    '            <sf-decorator ng-init="arrayIndex = $index" form="copyWithIndex($index)"></sf-decorator>\n' +
    '            <button ng-hide="form.readonly || form.remove === null" ng-click="deleteFromArray($index)" type="button"\n' +
    '                    class="btn btn-danger pull-right">\n' +
    '                Delete\n' +
    '                <i class="fa fa-trash"></i>\n' +
    '            </button>\n' +
    '        </uib-accordion-group>\n' +
    '    </uib-accordion>\n' +
    '    <div class="clearfix bottom-spaced">\n' +
    '        <button ng-hide="form.readonly || form.add === null" ng-click="appendToArray();form.openLast()" type="button"\n' +
    '                class="btn {{ form.style.add || \'btn-default\' }} pull-right">{{\n' +
    '            form.add || \'Add\'}}\n' +
    '        </button>\n' +
    '    </div>\n' +
    '    <div class="help-block" ng-show="(hasError() && errorMessage(schemaError())) || form.description"\n' +
    '         ng-bind-html="(hasError() && errorMessage(schemaError())) || form.description"></div>\n' +
    '</div>\n' +
    '\n' +
    '\n' +
    '');
}]);

angular.module('schemaFormBuilder').run(['$templateCache', function($templateCache) {
  $templateCache.put('builder/views/open.tpl.html',
    '<div class="modal-body">\n' +
    '    <table class="table table-striped">\n' +
    '        <tr ng-repeat="form in modal.forms">\n' +
    '            <td>{{ form.name}}</td>\n' +
    '            <td>\n' +
    '                <button class="btn btn-success btn-sm pull-right" ng-click="modal.open(form)">Open</button>\n' +
    '                <button class="btn btn-danger margin-right-20 btn-sm pull-right" ng-click="modal.delete($index, form)">Delete</button>\n' +
    '            </td>\n' +
    '        </tr>\n' +
    '    </table>\n' +
    '</div>\n' +
    '<div class="modal-footer">\n' +
    '    <button class="btn btn-success btn-sm" type="button" ng-click="modal.open({fields: []})">New Form</button>\n' +
    '    <button class="btn btn-warning btn-sm" type="button" ng-click="modal.cancel()">Cancel</button>\n' +
    '</div>');
}]);

angular.module('schemaFormBuilder').run(['$templateCache', function($templateCache) {
  $templateCache.put('builder/views/builder.tpl.html',
    '\n' +
    '<div class="body-section">\n' +
    '    <div class="header">\n' +
    '        <h4>\n' +
    '            <img src="images/logo.png" alt="">\n' +
    '            Schema Form <strong>Builder</strong> <span class="grey">/ {{ builder.model.name || \'Untitled Form\'}}</span>\n' +
    '            <a class="btn btn-sm btn-primary pull-right" ng-click="builder.newForm()">New Form</a>\n' +
    '            <a class="btn btn-sm btn-warning pull-right margin-right-20" ng-click="builder.openForm()">My previous Forms</a>\n' +
    '        </h4>\n' +
    '    </div>\n' +
    '    <div class="container">\n' +
    '        <!--<uib-alert type="default">Build your own form</uib-alert>-->\n' +
    '\n' +
    '        <div class="row">\n' +
    '            <div class="col-sm-6 builder">\n' +
    '                <form name="builderForm" ng-submit="builder.saveForm(builderForm)">\n' +
    '                    <div sf-schema="builder.schema" sf-form="builder.form" sf-model="builder.model"\n' +
    '                         sf-options="{ formDefaults: { ngModelOptions: { updateOn: \'blur\' } }}"></div>\n' +
    '                </form>\n' +
    '            </div>\n' +
    '            <div class="col-sm-6 preview">\n' +
    '                <h4>preview</h4>\n' +
    '                <div sf-schema="builder.display.schema" sf-form="builder.display.form"\n' +
    '                     sf-model="builder.display.model"></div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="instructions col-xs-12" ng-class="{\'visible\' : builder.instructionsVisible}">\n' +
    '            <div class="">\n' +
    '                <div ng-if="builder.model.type == \'schema-form\'">\n' +
    '                    <h2>Instructions <button class="btn btn-sm btn-primary pull-right"\n' +
    '                    ng-click="builder.instructionsVisible = false">back</button> </h2>\n' +
    '                    <p>In your angular project do the following</p>\n' +
    '                    <h4>First, Install angular-schema form</h4>\n' +
    '                    <p>Using bower:</p>\n' +
    '                    <pre>bower install angular-schema-form</pre>\n' +
    '                    <p>Using npm:</p>\n' +
    '                    <pre>npm install angular-schema-form</pre></p>\n' +
    '                    <p>Then add it as a dependency to your module</p>\n' +
    '                    <pre>angular.module(\'myModule\', [\'schemaForm\'])</pre>\n' +
    '                    <div class="separated"></div>\n' +
    '                    <h4>Secondly, Specify your schema and form</h4>\n' +
    '                    <p>In your controller, add the following schema and form an pass it to your views</p>\n' +
    '                    <div class="row">\n' +
    '                        <div class="col-sm-6">\n' +
    '                            <h5>Schema</h5>\n' +
    '                            <pre> {{ builder.output.schema | json }}</pre>\n' +
    '                        </div>\n' +
    '                        <div class="col-sm-6">\n' +
    '                            <h5>Forms</h5>\n' +
    '                            <pre> {{ builder.output.form | json }}</pre>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="separated"></div>\n' +
    '                    <h4>Lastly, Display the form in your view</h4>\n' +
    '                    <pre class="language-html" data-lang="html">\n' +
    '                        &lt;form name="myForm" ng-submit="submit()"&gt; <br>\n' +
    '                        &lt;div sf-schema="schema" sf-form="form" sf-model="model"&gt;&lt;/div&gt;<br>\n' +
    '                        &lt;input type="submit" value="Submit"&gt;<br>\n' +
    '                            &lt;button type="button" ng-click="goBack()"&gt;Cancel&lt;/button&gt;<br>\n' +
    '                        &lt;/form&gt;\n' +
    '                    </pre>\n' +
    '                </div>\n' +
    '                <div ng-if="builder.model.type == \'bootstrap\'">\n' +
    '                    <h3>To be created</h3>\n' +
    '                    <pre> {{ builder.output | json }}</pre>\n' +
    '                </div>\n' +
    '\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>');
}]);

'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name builder
   * @description
   *
   */
  angular.module('builder', ['angular-growl', 'angular-locker', 'schemaForm', 'ui.bootstrap', 'ui.router', 'ui.sortable']).config(['lockerProvider', function config(lockerProvider) {
    lockerProvider.defaults({
      driver: 'local',
      namespace: 'ro',
      separator: '.',
      eventsEnabled: true,
      extend: {}
    });
  }]).config(['growlProvider', function (growlProvider) {
    growlProvider.globalTimeToLive({ success: 1000, error: 2000, warning: 3000, info: 4000 });
  }]);
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name core
   * @description
   *
   */
  angular.module('builder').config(bootstrapTypeHeadDecorator);

  function bootstrapTypeHeadDecorator(schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {

    var typehead = function typehead(name, schema, options) {
      var form;
      if (schema.type === 'typehead' || schema.type['x-schema-form'] === 'typehead' || !_.isUndefined(form) && form.type === 'typehead') {
        form = schemaFormProvider.stdFormObj(name, schema, options);
        options.lookup[sfPathProvider.stringify(options.path)] = form;
        return form;
      }
    };

    schemaFormProvider.defaults.string.unshift(typehead);

    schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'typehead', 'builder/decorators/typehead/bootstrap-typehead-decorator.tpl.html');
    schemaFormDecoratorsProvider.createDirective('typehead', 'builder/decorators/typehead/bootstrap-typehead-decorator.tpl.html');
  }
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name core
   * @description
   *
   */
  angular.module('builder').config(bootstrapSimpleArrayDecorator);

  function bootstrapSimpleArrayDecorator(schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
    schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'simple-array', 'builder/decorators/simple-array/bootstrap-simple-array-decorator.tpl.html');
    schemaFormDecoratorsProvider.createDirective('simple-array', 'builder/decorators/simple-array/bootstrap-simple-array-decorator.tpl.html');
  }
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name core
   * @description
   *
   */
  angular.module('builder').config(bootstrapTypeHeadDecorator);

  function bootstrapTypeHeadDecorator(schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {

    schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'select-box', 'builder/decorators/select-box/bootstrap-select-box-decorator.tpl.html');
    schemaFormDecoratorsProvider.createDirective('select-box', 'builder/decorators/select-box/bootstrap-select-box-decorator.tpl.html');
  }
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name core
   * @description
   *
   */
  angular.module('builder').config(bootstrapDecorator);

  function bootstrapDecorator(schemaFormDecoratorsProvider) {
    schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'number', 'builder/decorators/number/bootstrap-number-decorator.tpl.html');
  }
})();
'use strict';

angular.module('schemaForm').config(['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider', function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {

  var datepicker = function datepicker(name, schema, options) {
    if (schema.type === 'string' && schema.format === 'date') {
      var f = schemaFormProvider.stdFormObj(name, schema, options);
      f.key = options.path;
      f.type = 'datepicker';
      options.lookup[sfPathProvider.stringify(options.path)] = f;
      return f;
    }
  };

  schemaFormProvider.defaults.string.unshift(datepicker);

  //Add to the bootstrap directive
  schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'datepicker', 'builder/decorators/datepicker/datepicker.html');
  schemaFormDecoratorsProvider.createDirective('datepicker', 'builder/decorators/datepicker/datepicker.html');
}]);
'use strict';

angular.module('schemaForm').config(['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider', function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {

  var ace = function ace(name, schema, options) {
    if (schema.type === 'ace') {
      var f = schemaFormProvider.stdFormObj(name, schema, options);
      f.key = options.path;
      f.type = 'ace';
      options.lookup[sfPathProvider.stringify(options.path)] = f;
      return f;
    }
  };

  schemaFormProvider.defaults.string.unshift(ace);

  //Add to the bootstrap directive
  schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'ace', 'builder/decorators/ace/ui-ace.html');
  schemaFormDecoratorsProvider.createDirective('ace', 'builder/decorators/ace/ui-ace.html');
}]);
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name core
   * @description
   *
   */
  angular.module('builder').config(bootstrapAccordionArrayDecorator);

  function bootstrapAccordionArrayDecorator(schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {

    //var accordion = function (name, schema, options) {
    //    var f = schemaFormProvider.stdFormObj(name, schema, options);
    //
    //    f.openLast = function(){
    //      alert('open');
    //    };
    //    options.lookup[sfPathProvider.stringify(options.path)] = f;
    //    return f;
    //};
    //
    //schemaFormProvider.defaults.array.unshift(accordion);

    schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'accordion-array', 'builder/decorators/accordion-array/bootstrap-accordion-array-decorator.tpl.html');
    schemaFormDecoratorsProvider.createDirective('accordion-array', 'builder/decorators/accordion-array/bootstrap-accordion-array-decorator.tpl.html');
  }
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name builder.factory:Converter
   *
   * @description
   *
   */
  angular.module('builder').factory('Converter', Converter);

  function Converter() {
    var ConverterBase = {};
    ConverterBase.generateStandardAttributes = function (field, output) {

      var form = undefined,
          formProps = ['key', 'condition', 'onChange', 'notitle', 'showAdvanced', 'validationMessage', 'onChange', 'ngModelOptions', 'condition', 'fieldAddonLeft', 'fieldAddonRight', 'description', 'showAdvanced', 'validationMessage', 'onChange', 'feedback', 'disableSuccessState', 'disableErrorState', 'placeholder', 'ngModelOptions', 'readonly', 'htmlClass', 'destroyStrategy', 'copyValueTo', 'fieldHtmlClass', 'labelHtmlClass'];
      output.schema.properties[field.key] = {
        title: field.title,
        description: field.description
      };

      form = _.pick(field, formProps);
      output.form.push(form);
      return output;
    };

    ConverterBase.updateForm = function (output, key, attr, value) {
      var index = _.findKey(output.form, 'key', key);
      output.form[index][attr] = value;
      return output;
    };

    ConverterBase.generateTextField = function (field, output) {
      output.schema.properties[field.key]['type'] = 'string';
      return output;
    };
    ConverterBase.generateTextareaField = function (field, output) {
      output.schema.properties[field.key]['type'] = 'string';
      output = ConverterBase.updateForm(output, field.key, 'type', 'textarea');
      return output;
    };
    ConverterBase.generateEmailField = function (field, output) {
      output.schema.properties[field.key]['type'] = 'string';
      output.schema.properties[field.key]['format'] = 'email';
      return output;
    };
    ConverterBase.generateDropdownField = function (field, output) {
      output.schema.properties[field.key]['type'] = 'string';
      output.schema.properties[field.key]['enum'] = field.options;
      return output;
    };
    ConverterBase.generateDateField = function (field, output) {
      output.schema.properties[field.key]['type'] = 'string';
      output.schema.properties[field.key]['format'] = 'date';
      return output;
    };
    ConverterBase.generateTimeField = function (field, output) {
      output.schema.properties[field.key]['type'] = 'string';
      output.schema.properties[field.key]['format'] = 'time';
      return output;
    };
    ConverterBase.generateDateTimeField = function (field, output) {
      output.schema.properties[field.key]['type'] = 'string';
      output.schema.properties[field.key]['format'] = 'date-time';
      return output;
    };

    var buildSegment = function buildSegment(field, output) {
      var builder = _.camelCase('generate_' + field.type.replace('-', '_') + '_field');
      output = ConverterBase.generateStandardAttributes(field, output);
      if (typeof ConverterBase[builder] === 'function') return ConverterBase[builder](field, output);
      output.schema.properties[field.key] = {
        type: field.type,
        title: field.title
      };
      return output;
    };

    ConverterBase.generateFields = function (model) {
      var output = { schema: { type: 'object', properties: {} }, form: [] };
      if (_.isArray(model.fields)) {
        model.fields.forEach(function (field) {
          if (!_.isUndefined(field.type) && !_.isUndefined(field.key)) output = buildSegment(field, output);
        });
      }
      return output;
    };
    return ConverterBase;
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var BuilderCtrl = function BuilderCtrl(Converter, growl, locker, $scope, $uibModal) {
    _classCallCheck(this, BuilderCtrl);

    var vm = this;

    vm.forms = locker.get('schema_forms', {} /* {
                                             'sample_form': {
                                             name: 'Sample Form',
                                             type: 'schema-form',
                                             fields: [
                                             {
                                             type: 'text',
                                             key: 'first_name',
                                             title: 'First name',
                                             open: false
                                             },
                                             {
                                             type: 'text',
                                             key: 'last_name',
                                             title: 'Last name',
                                             open: false
                                             },
                                             {
                                             type: 'email',
                                             key: 'email',
                                             title: 'Email',
                                             open: false
                                             },
                                             {
                                             type: 'date',
                                             key: 'dob',
                                             title: 'Date of Birth',
                                             open: false
                                             },
                                             {
                                             type: 'dropdown',
                                             key: 'marital-status',
                                             title: 'Marital Status',
                                             open: false
                                             },
                                             {
                                             type: 'date-time',
                                             key: 'check-in',
                                             title: 'Check In',
                                             open: false
                                             },
                                             {
                                             type: 'date-time',
                                             key: 'check-out',
                                             title: 'Check Out',
                                             open: false
                                             },
                                             {
                                             type: 'textarea',
                                             key: 'bio',
                                             title: 'Biography',
                                             open: false
                                             }
                                             ]
                                             }
                                             }*/);
    console.log(vm.forms);
    vm.schema = {
      type: 'object',
      title: 'Comment',
      properties: {
        name: {
          type: 'string'
        },
        type: {
          type: 'string',
          title: 'Form Output',
          'enum': ['schema-form', 'bootstrap']
        },
        fields: {
          type: 'array',
          title: 'Fields',
          items: {
            type: 'object',
            properties: {
              open: {
                type: 'boolean',
                'default': true
              },
              type: {
                title: 'Type',
                type: 'string',
                'enum': ['text', 'textarea', 'number', 'email', 'password', 'dropdown', 'radios', 'radios-inline', 'radiobuttons', 'checkbox', 'checkboxes', 'boolean', 'date', 'time', 'date-time', 'button', 'submit', 'reset', 'help', 'template']
              },
              key: {
                title: 'Key',
                type: 'string'
              },
              //description: 'Unique identifier'
              title: {
                condition: 'model.notitle',
                title: 'Title',
                type: 'string'
              },
              notitle: {
                type: 'boolean',
                title: 'Don\'t show title'
              },
              description: {
                title: 'Description',
                type: 'string'
              },
              validationMessage: {
                title: 'Validation Message',
                description: 'A custom validation error message. It can be a string, an object with error codes as key and messages as values or a custom message function',
                type: 'string'
              },
              onChange: {
                title: 'onChange',
                description: 'onChange event handler, expression or function. For expression, <code>modelValue</code> and <code>form</code> are both available. For a function, they will be passed as parameters in that order',
                type: 'string'
              },
              feedback: {
                title: 'Feedback Icon',
                description: 'Inline feedback icons. To turn off just set feedback to false. If set to a string that string is evaluated by a ngClass in the decorators scope. If not set att all the default value is <code>{ "glyphicon": true, "glyphicon-ok": hasSuccess(), "glyphicon-remove": hasError() }</code>',
                type: 'string'
              },
              disableSuccessState: {
                type: 'boolean',
                title: 'Disable Success State',
                'default': false
              },
              disableErrorState: {
                type: 'boolean',
                title: 'Disable Error State',
                'default': false
              },
              placeholder: {
                title: 'Placeholder',
                description: 'Placeholder on inputs and textarea',
                type: 'string'
              },
              ngModelOptions: {
                title: 'ng-Model Options',
                description: 'Passed along to ng-model-options',
                type: 'string'
              },
              readonly: {
                type: 'boolean',
                title: 'Readonly',
                'default': false
              },
              htmlClass: {
                title: 'Class',
                description: 'CSS Class(es) to be added to the container div e.g. : \'street foobar\'',
                type: 'string'
              },
              destroyStrategy: {
                title: 'Destroy Strategy',
                description: 'One of <code>null</code>, <code>empty</code> , <code>remove</code>, or <code>retain</code>. Changes model on $destroy event. default is <code>remove</code>.',
                type: 'string'
              },
              copyValueTo: {
                title: 'Copy Value To',
                description: 'Copy values to these schema keys e.g [\'address.street\']. The receiving fields can be shown, but the intent for them is to be hidden.',
                type: 'string'
              },
              fieldHtmlClass: {
                title: 'Field Class',
                description: 'CSS Class(es) to be added to field input (or similar)',
                type: 'string'
              },
              labelHtmlClass: {
                title: 'Label Class',
                description: 'CSS Class(es) to be added to the label of the field (or similar)',
                type: 'string'
              },
              condition: {
                title: 'Condition',
                description: 'Show or hide field depending on an angular expression e.g \'model.age < 18\'. The expression has access to <code>model</code>, <code>modelValue</code>, <code> arrayIndex</code>.  The condition need not reference a model value it could be anything on scope.',
                type: 'string'
              },
              fieldAddonLeft: {
                title: 'Field Addon - Left',
                description: 'Add html code to left of input field. For reference check <a target=\'_blank\' href=\'http://getbootstrap.com/components/#input-groups\'>bootstrap input groups</a>.',
                type: 'string'
              },
              fieldAddonRight: {
                title: 'Field Addon - Right',
                description: 'Add html code to right of input field. For reference check <a target=\'_blank\' href=\'http://getbootstrap.com/components/#input-groups\'>bootstrap input groups</a>.',
                type: 'string'
              },
              onClick: {
                title: 'onClick',
                description: 'Function to call when a button/submit is clicked',
                type: 'string'
              },
              showAdvanced: {
                title: 'Show advance options',
                type: 'boolean'
              }
            },
            required: ['type', 'key']
          }
        }
      },
      required: ['name']
    };
    vm.model = {};
    vm.form = [{
      type: 'section',
      htmlClass: 'row main-info',
      items: [{
        key: 'name',
        htmlClass: 'col-sm-6',
        placeholder: 'name of the form',
        notitle: true,
        fieldHtmlClass: 'field-name',
        labelHtmlClass: 'field-name-label'
      }, {
        key: 'type',
        htmlClass: 'col-sm-6',
        //notitle: true,
        fieldHtmlClass: 'output-type',
        labelHtmlClass: 'output-type-label'
      }]
    }, {
      type: 'section',
      htmlClass: 'my-field row',
      items: [{
        type: 'section',
        htmlClass: 'col-sm-6',
        items: [{
          type: 'help',
          helpvalue: '<h4>My Fields:</h4>'
        }]
      }, {
        type: 'section',
        htmlClass: 'col-sm-6',
        items: [{
          type: 'button',
          onClick: function onClick() {
            vm.instructionsVisible = true;
          },
          style: 'btn-success btn-sm pull-right',
          title: 'Generate Schema'
        }, {
          type: 'submit',
          style: 'btn-success btn-sm pull-right margin-right-20',
          title: 'Save'
        }]
      }]
    }, {
      key: 'fields',
      type: 'accordion-array',
      title: '{{ value.title || "Field "+ $index}}',
      add: 'Add a new Field',
      remove: 'Remove Field',
      startEmpty: true,
      items: [{
        key: 'fields[].title',
        htmlClass: 'hide-label',
        placeholder: 'Title'
      }, {
        type: 'section',
        htmlClass: 'row',
        items: [{
          key: 'fields[].type',
          placeholder: 'Type',
          notitle: true,
          htmlClass: 'col-sm-6 hide-label'
        }, {
          key: 'fields[].key',
          //type: 'section',
          placeholder: 'Key (Unique Identifier)',
          notitle: true,
          htmlClass: 'col-sm-6 hide-label'
        }]
      }, {
        key: 'fields[].open',
        notitle: true,
        type: 'hidden'
      }, {
        key: 'fields[].description',
        type: 'textarea',
        placeholder: 'Description',
        notitle: true
      }, {
        type: 'section',
        htmlClass: 'row',
        items: [{
          key: 'fields[].notitle',
          htmlClass: 'col-sm-6'
        }, {
          key: 'fields[].showAdvanced',
          htmlClass: 'col-sm-6'
        }]
      }, {
        condition: 'model.fields[arrayIndex].showAdvanced',
        type: 'help',
        helpvalue: '<hr/>'
      }, {
        type: 'section',
        htmlClass: 'row',
        items: [{
          type: 'section',
          htmlClass: 'col-md-4',
          items: [{
            condition: 'model.fields[arrayIndex].showAdvanced',
            key: 'fields[].disableSuccessState'
          }]
        }, {
          type: 'section',
          htmlClass: 'col-md-4',
          items: [{
            condition: 'model.fields[arrayIndex].showAdvanced',
            key: 'fields[].disableErrorState'
          }]
        }, {
          type: 'section',
          htmlClass: 'col-md-4',
          items: [{
            condition: 'model.fields[arrayIndex].showAdvanced',
            key: 'fields[].readonly'
          }]
        }]
      }, {
        condition: 'model.fields[arrayIndex].showAdvanced',
        type: 'help',
        helpvalue: '<hr/>'
      }, {
        condition: 'model.fields[arrayIndex].showAdvanced',
        key: 'fields[].validationMessage',
        type: 'textarea'
      }, {
        condition: 'model.fields[arrayIndex].showAdvanced',
        key: 'fields[].onChange',
        type: 'textarea'
      }, {
        condition: 'model.fields[arrayIndex].showAdvanced',
        key: 'fields[].feedback'
      }, {
        condition: 'model.fields[arrayIndex].showAdvanced',
        key: 'fields[].placeholder'
      }, {
        condition: 'model.fields[arrayIndex].showAdvanced',
        key: 'fields[].ngModelOptions',
        type: 'textarea'
      }, {
        condition: 'model.fields[arrayIndex].showAdvanced',
        key: 'fields[].htmlClass'
      }, {
        condition: 'model.fields[arrayIndex].showAdvanced',
        key: 'fields[].destroyStrategy'
      }, {
        condition: 'model.fields[arrayIndex].showAdvanced',
        key: 'fields[].copyValueTo'
      }, {
        condition: 'model.fields[arrayIndex].showAdvanced',
        key: 'fields[].fieldHtmlClass'
      }, {
        condition: 'model.fields[arrayIndex].showAdvanced',
        key: 'fields[].labelHtmlClass'
      }, {
        condition: 'model.fields[arrayIndex].showAdvanced',
        key: 'fields[].condition'
      }, {
        condition: 'model.fields[arrayIndex].showAdvanced',
        'key': 'fields[].fieldAddonLeft'
      }, {
        condition: 'model.fields[arrayIndex].showAdvanced',
        key: 'fields[].fieldAddonRight'
      }]
    }];
    vm.output = { schema: {}, form: [] };

    vm.saveForm = function (form) {
      $scope.$broadcast('schemaFormValidate');
      if (form.$valid) {
        persistForm();
      }
    };
    vm.newForm = function () {
      persistForm();
      vm.model = {
        fields: []
      };
      console.log(vm.model);
    };
    vm.openForm = function () {
      var modalInstance = $uibModal.open({
        templateUrl: 'builder/views/open.tpl.html',
        controller: function controller($uibModalInstance, forms) {
          var vm = this;
          vm.forms = forms;
          vm.open = function (form) {
            $uibModalInstance.close(form);
          };

          vm['delete'] = function (index, form) {
            if (confirm('About to delete ' + form.name)) {
              vm.forms.slice(vm.forms, index, 1);
              locker.put('schema_forms', vm.forms);
            }
          };

          vm.cancel = function () {
            $uibModalInstance.dismiss();
          };
        },
        controllerAs: 'modal',
        resolve: {
          forms: function forms() {
            return vm.forms;
          }
        }
      });

      modalInstance.result.then(function (form) {
        persistForm();
        vm.model = form;
        generateOutput(vm.model);
      });
    };

    if (!vm.model.name) {
      vm.openForm();
    }

    function generateOutput(update) {
      vm.output = Converter.generateFields(update);
      console.log(vm.output);
      vm.display = angular.copy(vm.output);
    }

    function persistForm() {
      if (vm.model.name && vm.model.name.length > 0) {
        vm.forms[_.snakeCase(vm.model.name)] = vm.model;
        locker.put('schema_forms', vm.forms);
        growl.success('Form ' + vm.model.name + ' Saved');
      }
    }

    $scope.$watch(function () {
      return vm.model;
    }, function (update) {
      generateOutput(update);
    }, true);
  }
  /**
   * @ngdoc object
   * @name builder.controller:BuilderCtrl
   *
   * @description
   *
   */
  ;

  angular.module('builder').controller('BuilderCtrl', BuilderCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('builder').config(config);

  function config($stateProvider) {
    $stateProvider.state('builder', {
      url: '/builder',
      templateUrl: 'builder/views/builder.tpl.html',
      controller: 'BuilderCtrl',
      controllerAs: 'builder'
    });
  }
})();
'use strict';

(function () {
  'use strict';

  angular.module('schemaFormBuilder').config(config);

  function config($urlRouterProvider) {
    $urlRouterProvider.otherwise('/builder');
  }
})();